import React from 'react'
import { Text } from 'theme-ui'

import { CtaStyled, CtaContainerStyled, CtaContentStyled, CtaContentTitleStyled, CtaContentSubtitleStyled, CtaButtonStyled } from './styles'
import Button from './../../atoms/Button'
import { CtaProps } from './types'

const Cta: React.FC<CtaProps> = ({ data }) => {
  const { title, subtitle, cta } = data

  return (
    <CtaStyled>
      <CtaContainerStyled>
        <CtaContentStyled>
          {title && (
            <CtaContentTitleStyled>
              <Text
                sx={{
                  variant: 'headingRaleway6',
                  fontFamily: 'secondary',
                  fontWeight: 'bold'
                }}
              >
                {title}
              </Text>
            </CtaContentTitleStyled>
          )}
          {subtitle && (
            <CtaContentSubtitleStyled>
              <Text
                sx={{
                  variant: 'bodyRaleway5',
                  fontFamily: 'primary'
                }}
              >
                {subtitle}
              </Text>
            </CtaContentSubtitleStyled>
          )}
        </CtaContentStyled>
        <CtaButtonStyled>{cta && <Button variant="withArrow" {...cta} />}</CtaButtonStyled>
      </CtaContainerStyled>
    </CtaStyled>
  )
}

export default Cta
